module.exports = __webpack_public_path__ + "img/jmfc002.e68a546c.png";